import { axios } from "@v2/shared/api";
const PARTICIPANT_ENDPOINT = "participants";
const PERSONAL_PASS_ENDPOINT = "personal-passes";

export default {
  getAll(eventId, type, page, lastname, order_by) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${PERSONAL_PASS_ENDPOINT}?type=${type}&page=${page}&order_name=${lastname}&order_by=${order_by}`
    );
  },

  get(eventId, passId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${PERSONAL_PASS_ENDPOINT}/${passId}`
    );
  },

  downloadPersonalPass(eventId, passId) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${PERSONAL_PASS_ENDPOINT}/${passId}/download`,
      {
        responseType: "arraybuffer"
      }
    );
  },

  downloadAllPersonalPass(eventId, type) {
    return axios.get(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${PERSONAL_PASS_ENDPOINT}/download?type=${type}`,
      {
        responseType: "arraybuffer"
      }
    );
  },

  add(eventId, pass) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${PERSONAL_PASS_ENDPOINT}`,
      pass
    );
  },

  addParticipantPass(eventId, pass, type) {
    return this.add(eventId, { ...pass, type });
  },

  addMontagePass(eventId, pass) {
    return this.add(eventId, { ...pass, type: "installation" });
  },

  addStaffPass(eventId, pass) {
    return this.add(eventId, { ...pass, type: "staff" });
  },

  uploadPasses(eventId, data) {
    return axios.post(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${PERSONAL_PASS_ENDPOINT}/import`,
      data
    );
  },

  delete(eventId, passId) {
    return axios.delete(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${PERSONAL_PASS_ENDPOINT}/${passId}`
    );
  },

  deleteAll(eventId, type) {
    return axios.delete(
      `${PARTICIPANT_ENDPOINT}/${eventId}/${PERSONAL_PASS_ENDPOINT}?type=${type}`
    );
  },

  deleteAllParticipantPasses(eventId) {
    return this.deleteAll(eventId, "certificate");
  },

  deleteAllInstallationPasses(eventId) {
    return this.deleteAll(eventId, "installation");
  },

  deleteAllStaffPasses(eventId) {
    return this.deleteAll(eventId, "staff");
  }
};
